export const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')

export function indexLetter(name: string): string {
  const raw = name.trim()
  if (!raw) return '#'
  const first = raw[0]!.toLocaleUpperCase('de-CH')
  const ch = first === 'Ä' ? 'A' : first === 'Ö' ? 'O' : first === 'Ü' ? 'U' : first[0]!
  return ch >= 'A' && ch <= 'Z' ? ch : '#'
}

export function groupByLetter<T>(items: T[], getText: (item: T) => string): [string, T[]][] {
  const map = new Map<string, T[]>()
  for (const item of items) {
    const L = indexLetter(getText(item))
    const arr = map.get(L)
    if (arr) arr.push(item)
    else map.set(L, [item])
  }
  return [...map.entries()]
}

export function railLettersFor(have: Iterable<string>): string[] {
  const set = have instanceof Set ? have : new Set(have)
  return set.has('#') ? [...LETTERS, '#'] : LETTERS
}
